// const api_host = "http://localhost:8000"
const api_host = "http://glycopeptideatlas-eb-env.eba-zxebtsmp.us-west-2.elasticbeanstalk.com"
export async function fetchPCAData(props) {
    try {
      const project = props.selectedOption.value; // Assuming selectedOption is an object with a value property
      const api_path = `/api/get-pca-data/?project=${project}`;
      const full_api_path = `${api_host}${api_path}`;
      const response = await fetch(full_api_path);
      
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      console.log("Data from API:", data);  // Debugging line

      return data;
  
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;  // Propagate the error back
    }
}

export const pcaChartOptions = {
    chart: {
        id: "basic-scatter-plot",
        toolbar: {
            show: false,
        },
        offsetX: +0,
    },
    title: {
        text: 'PCA',
        align: 'center',
        margin: 20,
        style: {
            fontSize: '24px'
        }
    },
    colors: ['#FF0000', '#0000FF'],
    xaxis: {
        type: 'numeric', // 'numeric' or 'datetime' or 'category'
        tickAmount: 10,  // Number of ticks to show on x-axis
        // min: 1990,          // Minimum value
        // max: 2000,        // Maximum value
        title: {
            text: "PC-1"
        },
        tickPlacement: 'on'
    },
    yaxis: {
        title: {
            text: "PC-2"
        },
        type: 'numeric', // 'numeric' or 'datetime' or 'category'
        tickAmount: 10,  // Number of ticks to show on x-axis
        tickPlacement: 'on',
        labels: {
            formatter: function (val) {
                return val.toFixed(1);  // Round to one decimal place
            }
        }

    },
    markers: {
        size: 6
    }
};

const api_host_volcano = "http://127.0.0.1:8000"

export async function fetchDiffVolcanoData(props) {
    try {
      const project = props.selectedOption.value; // Assuming selectedOption is an object with a value property
      const api_path = `/api/get-diff-volcano-data/?project=${project}`;
      const full_api_path = `${api_host_volcano}${api_path}`;
      const response = await fetch(full_api_path);
      
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      console.log("Data from API:", data);  // Debugging line

      return data;
  
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;  // Propagate the error back
    }
}

export const volcanoChartOptions = {
    chart: {
        id: "basic-scatter-plot",
        toolbar: {
            show: false,
        },
        offsetX: +0,
    },
    title: {
        text: 'Volcano',
        align: 'center',
        margin: 20,
        style: {
            fontSize: '24px'
        }
    },

    xaxis: {
        type: 'numeric', // 'numeric' or 'datetime' or 'category'
        tickAmount: 10,  // Number of ticks to show on x-axis
        // min: 1990,          // Minimum value
        // max: 2000,        // Maximum value
        title: {
            text: "log2 Fold Change"
        },
        tickPlacement: 'on'
    },
    yaxis: {
        title: {
            text: "-log10(FDR)"
        },
        type: 'numeric', // 'numeric' or 'datetime' or 'category'
        tickAmount: 10,  // Number of ticks to show on x-axis
        tickPlacement: 'on'

    },
    annotations: {
        xaxis: [
            {
                x: 0,
                borderColor: '#999',
                yAxisIndex: 0,
                label: {
                    show: false
                }
            },
            {
                x: -1,
                strokeDashArray: 5,
                borderColor: '#000000',
                label: {
                    borderColor: '#000000',
                    style: {
                        color: '#000000',
                        background: '#FFFFFF',
                    },
                    //   text: 'x = -1',
                },
            },
            {
                x: 1,
                strokeDashArray: 5,
                borderColor: '#000000',
                label: {
                    borderColor: '#000000',
                    style: {
                        color: '#000000',
                        background: '#FFFFFF',
                    },
                    //   text: 'x = 1',
                },
            }
        ],
        yaxis: [
            {
                y: 2,
                borderColor: '#999',
                label: {
                    show: false
                }
            }
        ]
    },

    markers: {
        size: 6
    }
};
